'use client';

import { createContext, useContext } from 'react';

/**
 * Tenant-level IANA timezone, resolved on the server (tenant_configs.timezone)
 * and seeded into the shell so the tenant-wide view — "All Facilities", i.e.
 * currentFacility === null — resolves the tenant's timezone instead of the
 * Australia/Sydney hardcode.
 *
 * `null` means "not resolved" — useTimezone() then falls back through
 * resolveTimezone's chain to DEFAULT_TIMEZONE. When a facility IS selected the
 * facility timezone/state wins ahead of this value (see resolveTimezone).
 *
 * Mirrors contexts/module-context.tsx: a single Provider mounted at the shell
 * level, a thin useContext hook for consumers.
 */
const TenantTimezoneContext = createContext<string | null>(null);

export const TenantTimezoneProvider = TenantTimezoneContext.Provider;

/** Access the server-seeded tenant timezone, or null when unresolved. */
export function useTenantTimezone(): string | null {
  return useContext(TenantTimezoneContext);
}
